import { client } from './client';
import { appConfig } from '../config/app-config';
import { ProductPermissions } from '../constants/constants';
import { User } from '../types/types';

export const getCurrentUser = (): Promise<User> =>
  client('users/current', { method: 'GET' }, appConfig.apiUrls.container, true);

export const getUserPermissions = (
  productType: string
): Promise<ProductPermissions[]> =>
  client(
    `users/current/permissions/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',
    { method: 'GET' },
    appConfig.apiUrls.container,
    false
  );

export const GetUserRole = async (Payload: any) => {
  return await client(
    `menu-and-stores`,
    { method: 'POST', body: Payload },
    appConfig.apiUrls.menu
  );
};

export const GetState = async () => {
  try {
    return await client(
      `customer/state`,
      { method: 'GET' },
      appConfig.apiUrls.customer
    );
  } catch (e: any) {
    return null;
  }
};

export const postSearch = async (payload: any) => {
  try {
    return await client(
      `customercheck/search`,
      {
        method: 'POST',
        data: payload,
      },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return 'Error';
  }
};
